<template>
	<span class="eia-caption">
		<slot></slot>
	</span>
</template>

<script>
export default {
	name: 'eia-caption',
};
</script>

<style lang="scss" scoped>
.eia-caption {
	display: inline-block;
	font-size: $text-subheading-small;
	line-height: 1.4;
	color: $color-grey-dark;
	margin: 8px 0;
}
</style>
